<div>
  <div class="flex justify-center w-full h-full pt-32">
    <div class="flex flex-col gap-16 md:gap-24 items-center justify-center w-full max-w-[636px]">
      <fun-icon [name]="'bell'" [style]="'w-72 h-72 stroke-[2px] stroke-orange-100'"></fun-icon>
      <p class="text-h500 md:text-h600 font-sans text-center text-eggplant-100 md:pt-12">{{ 'NOTIFICATIONS.ADVISE_TITLE' | translate }}</p>
      <p class="font-sans text-m md:text-l text-center text-eggplant-100/[0.55]">{{ 'NOTIFICATIONS.ADVISE_SUBTITLE' | translate }}</p>
    </div>
  </div>

  <div class="flex justify-center w-full h-full py-24 md:py-32 px-12">
    <div class="flex gap-12 justify-center px-12 py-6 rounded rounded-xl bg-gray-10/[0.1] border border-eggplant-100/[0.1]">
      <div class="pt-4">
        <fun-icon [name]="'bell'" [style]="'w-16 h-16 stroke-[2px] stroke-eggplant-100/[0.55]'"></fun-icon>
      </div>
      <p class="font-sans text-m md:text-l text-left text-eggplant-100/[0.55] [&>span]:text-orange-100 [&>span]:underline [&>span]:underline-offset-6" [innerHTML]="advise"></p>
    </div>
  </div>

  <div class="flex justify-center w-full h-full pb-32 md:pb-32">
    <div class="flex flex-col gap-8 md:gap-16 items-center justify-center w-full max-w-[720px]">
      <fun-new-button  [classExtra]="' !w-full '" [buttonType]="'colorFull'" [size]="'xl'"
      title="{{ 'NOTIFICATIONS.ADVISE_ACTIVATE_CTA' | translate }}" (eventClick)="activate(true)" icon="rocket" iconPosition="right"></fun-new-button>
      <fun-new-button  [classExtra]="' !w-full '" [buttonType]="'ghost'" [size]="'s'"
      title="{{ 'NOTIFICATIONS.ADVISE_DONT_ACTIVATE_CTA' | translate }}" (eventClick)="activate(false)"></fun-new-button>
    </div>
  </div>
</div>